'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Common = require('./common');
var Ref = require('./ref');
var internals = {};
exports.schema = function (Joi, config) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Common.assertOptions(options, ['appendPath', 'override']);
  try {
    return internals.schema(Joi, config, options);
  } catch (err) {
    if (options.appendPath && err.path !== undefined) {
      err.message = "".concat(err.message, " (").concat(err.path, ")");
    }
    throw err;
  }
};
internals.schema = function (Joi, config, options) {
  Assert(config !== undefined, 'Invalid undefined schema');
  if (Array.isArray(config)) {
    Assert(config.length, 'Invalid empty array schema');
    if (config.length === 1) {
      config = config[0];
    }
  }
  var valid = function valid(base) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    if (options.override !== false) {
      return base.valid.apply(base, [Joi.override].concat(values));
    }
    return base.valid.apply(base, values);
  };
  if (internals.simple(config)) {
    return valid(Joi, config);
  }
  if (typeof config === 'function') {
    return Joi.custom(config);
  }
  Assert(typeof config === 'object', 'Invalid schema content:', typeof config);
  if (Common.isResolvable(config)) {
    return valid(Joi, config);
  }
  if (Common.isSchema(config)) {
    return config;
  }
  if (Array.isArray(config)) {
    var _iterator = _createForOfIteratorHelper(config),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (!internals.simple(item)) {
          var _Joi$alternatives;
          return (_Joi$alternatives = Joi.alternatives()).try.apply(_Joi$alternatives, _toConsumableArray(config));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return valid.apply(void 0, [Joi].concat(_toConsumableArray(config)));
  }
  if (config instanceof RegExp) {
    return Joi.string().regex(config);
  }
  if (config instanceof Date) {
    return valid(Joi.date(), config);
  }
  Assert(Object.getPrototypeOf(config) === Object.getPrototypeOf({}), 'Schema can only contain plain objects');
  return Joi.object().keys(config);
};
exports.ref = function (id, options) {
  return Ref.isRef(id) ? id : Ref.create(id, options);
};
exports.compile = function (root, schema) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Common.assertOptions(options, ['legacy']);

  // Compiled by any supported version

  var any = schema && schema[Common.symbols.any];
  if (any) {
    Assert(options.legacy || any.version === Common.version, 'Cannot mix different versions of joi schemas:', any.version, Common.version);
    return schema;
  }

  // Uncompiled root

  if (typeof schema !== 'object' || !options.legacy) {
    return exports.schema(root, schema, {
      appendPath: true
    }); // Will error if schema contains other versions
  }

  // Scan schema for compiled parts

  var compiler = internals.walk(schema);
  if (!compiler) {
    return exports.schema(root, schema, {
      appendPath: true
    });
  }
  return compiler.compile(compiler.root, schema);
};
internals.walk = function (schema) {
  if (typeof schema !== 'object') {
    return null;
  }
  if (Array.isArray(schema)) {
    var _iterator2 = _createForOfIteratorHelper(schema),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        var compiler = internals.walk(item);
        if (compiler) {
          return compiler;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return null;
  }
  var any = schema[Common.symbols.any];
  if (any) {
    return {
      root: schema[any.root],
      compile: any.compile
    };
  }
  Assert(Object.getPrototypeOf(schema) === Object.getPrototypeOf({}), 'Schema can only contain plain objects');
  for (var key in schema) {
    var _compiler = internals.walk(schema[key]);
    if (_compiler) {
      return _compiler;
    }
  }
  return null;
};
internals.simple = function (value) {
  return value === null || ['boolean', 'string', 'number'].includes(typeof value);
};
exports.when = function (schema, condition, options) {
  if (options === undefined) {
    Assert(condition && typeof condition === 'object', 'Missing options');
    options = condition;
    condition = Ref.create('.');
  }
  if (Array.isArray(options)) {
    options = {
      switch: options
    };
  }
  Common.assertOptions(options, ['is', 'not', 'then', 'otherwise', 'switch', 'break']);

  // Schema condition

  if (Common.isSchema(condition)) {
    Assert(options.is === undefined, '"is" can not be used with a schema condition');
    Assert(options.not === undefined, '"not" can not be used with a schema condition');
    Assert(options.switch === undefined, '"switch" can not be used with a schema condition');
    return internals.condition(schema, {
      is: condition,
      then: options.then,
      otherwise: options.otherwise,
      break: options.break
    });
  }

  // Single condition

  Assert(Ref.isRef(condition) || typeof condition === 'string', 'Invalid condition:', condition);
  Assert(options.not === undefined || options.is === undefined, 'Cannot combine "is" with "not"');
  if (options.switch === undefined) {
    var _rule = options;
    if (options.not !== undefined) {
      _rule = {
        is: options.not,
        then: options.otherwise,
        otherwise: options.then,
        break: options.break
      };
    }
    var is = _rule.is !== undefined ? schema.$_compile(_rule.is) : schema.$_root.invalid(null, false, 0, '').required();
    Assert(_rule.then !== undefined || _rule.otherwise !== undefined, 'options must have at least one of "then", "otherwise", or "switch"');
    Assert(_rule.break === undefined || _rule.then === undefined || _rule.otherwise === undefined, 'Cannot specify then, otherwise, and break all together');
    if (options.is !== undefined && !Ref.isRef(options.is) && !Common.isSchema(options.is)) {
      is = is.required(); // Only apply required if this wasn't already a schema or a ref
    }
    return internals.condition(schema, {
      ref: exports.ref(condition),
      is: is,
      then: _rule.then,
      otherwise: _rule.otherwise,
      break: _rule.break
    });
  }

  // Switch statement

  Assert(Array.isArray(options.switch), '"switch" must be an array');
  Assert(options.is === undefined, 'Cannot combine "switch" with "is"');
  Assert(options.not === undefined, 'Cannot combine "switch" with "not"');
  Assert(options.then === undefined, 'Cannot combine "switch" with "then"');
  var rule = {
    ref: exports.ref(condition),
    switch: [],
    break: options.break
  };
  for (var i = 0; i < options.switch.length; ++i) {
    var test = options.switch[i];
    var last = i === options.switch.length - 1;
    Common.assertOptions(test, last ? ['is', 'then', 'otherwise'] : ['is', 'then']);
    Assert(test.is !== undefined, 'Switch statement missing "is"');
    Assert(test.then !== undefined, 'Switch statement missing "then"');
    var item = {
      is: schema.$_compile(test.is),
      then: schema.$_compile(test.then)
    };
    if (!Ref.isRef(test.is) && !Common.isSchema(test.is)) {
      item.is = item.is.required(); // Only apply required if this wasn't already a schema or a ref
    }
    if (last) {
      Assert(options.otherwise === undefined || test.otherwise === undefined, 'Cannot specify "otherwise" inside and outside a "switch"');
      var otherwise = options.otherwise !== undefined ? options.otherwise : test.otherwise;
      if (otherwise !== undefined) {
        Assert(rule.break === undefined, 'Cannot specify both otherwise and break');
        item.otherwise = schema.$_compile(otherwise);
      }
    }
    rule.switch.push(item);
  }
  return rule;
};
internals.condition = function (schema, condition) {
  for (var _i = 0, _arr = ['then', 'otherwise']; _i < _arr.length; _i++) {
    var key = _arr[_i];
    if (condition[key] === undefined) {
      delete condition[key];
    } else {
      condition[key] = schema.$_compile(condition[key]);
    }
  }
  return condition;
};